import useCommonStore from 'hooks/useCommonStore';
import { SET_SIGNUP_PII_INFORMATION } from 'store/action';
import {
  RESET_PII_PROFILE_PERSONAL_DETAILS,
  RESET_PII_PROFILE_RESIDENTIAL_ADDRESS,
  RESET_SIGNUP_PII_INFORMATION,
} from '../const';

const usePIIStore = () => {
  const { state, setState, dispatch, setLoading } = useCommonStore();
  const { signupPIIInformation } = state || {};
  const { personalDetails, residentialAddress } = signupPIIInformation || {};

  const setPIIProfilePersonalDetails = (
    payload = RESET_PII_PROFILE_PERSONAL_DETAILS
  ) => {
    setState({
      action: SET_SIGNUP_PII_INFORMATION,
      payload: {
        ...signupPIIInformation,
        personalDetails: payload,
      },
    });
  };

  const setPIIProfileResidentialAddress = (
    payload = RESET_PII_PROFILE_RESIDENTIAL_ADDRESS
  ) => {
    setState({
      action: SET_SIGNUP_PII_INFORMATION,
      payload: {
        ...signupPIIInformation,
        residentialAddress: payload,
      },
    });
  };

  const resetSignupPIIInformation = () => {
    setState({
      action: SET_SIGNUP_PII_INFORMATION,
      payload: RESET_SIGNUP_PII_INFORMATION,
    });
  };

  return {
    ...state,
    state,
    setState,
    dispatch,
    setLoading,
    signupPIIInformation,
    personalDetails,
    residentialAddress,
    setPIIProfilePersonalDetails,
    setPIIProfileResidentialAddress,
    resetSignupPIIInformation,
  };
};

export default usePIIStore;
